import { css } from 'styled-components'

import { spaces } from '@/config/global-parameters'

export const showInMobile = css`
  @media (min-width: calc(${spaces.tabletBreakpoint} + 1px)) {
    display: none;
  }
`

export const showInDesktop = css`
  @media (max-width: ${spaces.tabletBreakpoint}) {
    display: none;
  }
`
